import { Resolucao } from '../@types';
import Service from './Service';

class ResolucaoService extends Service {
  static getResolucoes() {
    return this.Http.get<Resolucao.ResolucaoQuestao[]>('/resolutions/byuser').then(this.getData);
  }

  static getMockTestResolutions() {
    return this.Http.get<Resolucao.ResolucaoQuestao[]>('/resolutions/byregistereduser').then(this.getData);
  }

  static getRegisteredResolutions(registeredID : string) {
    return this.Http.get<Resolucao.ResolucaoQuestao[]>(`resolutions/register/${registeredID}`).then(this.getData);
  }

  static getResolucao(id: number) {
    return this.Http.get<Resolucao.ResolucaoQuestao>(`/resolucaoQuestao/${id}`).then(this.getData);
  }

  static confirmarResposta(resolucaoQuestao: Resolucao.ResolucaoQuestao) {
    delete resolucaoQuestao.questionId; 
    delete resolucaoQuestao.userId; 
    return this.Http.post<Resolucao.ResolucaoQuestao>(
      '/resolutions/submit',
      resolucaoQuestao
    ).then(this.getData);
  }

  static update(resolucaoQuestao: Resolucao.ResolucaoQuestao) {
    delete resolucaoQuestao.question;
    return this.Http.put<Resolucao.ResolucaoQuestao>(
      '/resolutions',
      resolucaoQuestao
    ).then(this.getData);
  }

  static exibirResposta(resolucaoQuestao: Resolucao.ResolucaoQuestao) {
    delete resolucaoQuestao.questionId;
    delete resolucaoQuestao.userId;

    return this.Http.post<Resolucao.ResolucaoQuestao>(
      '/resolutions/show',
      resolucaoQuestao
    ).then(this.getData);
  }

  static getTagCounts() {
    return this.Http.get<{ tag: string; count: number }[]>('/resolutions/tagcounts').then(this.getData);
  }

  static getSubjectHistory() {
    return this.Http.get<{ subjectId: string; subjectName: string; total: number; correct: number; wrong: number }[]>(
      '/resolutions/bysubject'
    ).then(this.getData);
  }

  static clearSubjectHistory(subjectId: string) {
    return this.Http.delete<{ deleted: number }>(`/resolutions/bysubject/${subjectId}`).then(this.getData);
  }
}

export default ResolucaoService;
